export default __webpack_public_path__ + "static/media/smileys.947dc657.svg";